import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';

import { isStatusActive } from '../../../prisma-xs/helpers/bom-mapper.helper';
import { ProductStatus } from '../../../shared/models/product.model';
import { BomTableIdentifier } from '../../../prisma-xs/models/bom.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-article-counter',
    templateUrl: './article-counter.component.html',
    styleUrls: ['./article-counter.component.scss'],
    standalone: false
})
export class ArticleCounterComponent implements OnChanges {

  @Input() counter: number;
  @Input() apartmentsCount: number;
  @Input() quantityChangeable: boolean;
  @Input() status: ProductStatus;
  @Input() tableIdentifier: BomTableIdentifier;

  @Output() quantityDecrease = new EventEmitter<number>();
  @Output() quantityIncrease = new EventEmitter<number>();
  @Output() quantityChanged = new EventEmitter<boolean>();

  onIncreaseQuantity() {
    if(!isStatusActive(this.status)){
      return;
    }
    this.counter += 1;
    this.quantityIncrease.emit(this.counter);
  }

  onDecreaseQuantity() {
    if(!isStatusActive(this.status)){
      return;
    }
    if (this.counter > 1) {
      this.counter -= 1;
    }
    this.quantityDecrease.emit(this.counter);
  }

  isAccessoriesTable() {
    return this.tableIdentifier === BomTableIdentifier.ACCESSORIES || this.tableIdentifier === BomTableIdentifier.PROJECT_COMPONENTS;
  }

  counterChangedForSecondTime(changes: SimpleChanges) {
    return 'counter' in changes && !changes?.counter?.firstChange;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.isAccessoriesTable() && this.counterChangedForSecondTime(changes)) {
      this.quantityChanged.emit(true);
    }
  }
}
